














import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Gateway, Node, Product, Sensor, Transceiver } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import { LastCheckInService } from '@/services/last-check-in-service';

@Component({
	components: { BillingSetupButton, InformationRow },
})
export default class LastCheckInTag extends Vue {
	@Prop({ required: false })
	public entity?: Transceiver | Sensor | Gateway | Node;

	@Prop({ required: true })
	public entityType!: 'transceiver' | 'sensor' | 'gateway' | 'node';

	@Prop({ required: false })
	public hideSpacer?: boolean;

	private lastCheckIn: number = -1;

	@Watch('sensor')
	public async created() {
		if (this.entity?.id) {
			LastCheckInService.getLastCheckIn(this.entityType, this.entity.id).then(
				lastCheckInResponse => {
					if (!lastCheckInResponse.errorMessage) {
						this.lastCheckIn = lastCheckInResponse.lastCheckInTimestamp ?? -1;
					}
				},
			);
		}
	}
}
